import { API_ENV } from '@nankai/admin/apis/fetchUtils';
import nankaiLogo from '@nankai/admin/assets/nankai_logo.png';
import LayoutUser from '@nankai/admin/components/LayoutUser';
import cls from 'clsx';
import styles from './layoutHeader.module.css';

interface LayoutHeaderProps {
  webTitle: string;
}

const isProd = API_ENV === 'production';

const LayoutHeader: React.FC<LayoutHeaderProps> = ({ webTitle }) => {
  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <a
          href="/dashboard"
          className={cls(styles.logo, { [styles.notProd]: !isProd })}
        >
          <img src={nankaiLogo} alt={webTitle} style={{ height: '50px' }} />
          {!isProd && (
            <h4
              style={{
                color: 'red',
                marginLeft: '20px',
                display: 'flex',
                alignItems: 'center'
              }}
            >{`${API_ENV}`}</h4>
          )}
        </a>
        <LayoutUser />
      </div>
    </header>
  );
};

export default LayoutHeader;
